//@flow
import { createSelector } from 'reselect'
import { MODULE, FETCH_CONFIG_RESOURCE } from './constants'
import { hgetAll, hget } from '../hash/selectors'
import {
  isCommSuccess,
  isCommInProgress,
  isCommFailure
} from '../communication'

const EMPTY_CONFIG = {}
export const getConfig = (state: any) => hgetAll(MODULE, state) || EMPTY_CONFIG

export const getConfigSetting = (settingName: string) =>
  createSelector(hget(MODULE, settingName))

export const isConfigLoaded = (state: any) =>
  isCommSuccess(FETCH_CONFIG_RESOURCE, state)

export const isConfigLoading = (state: any) =>
  isCommInProgress(FETCH_CONFIG_RESOURCE, state)

export const isConfigFailed = (state: any) =>
  isCommFailure(FETCH_CONFIG_RESOURCE, state)



// WEBPACK FOOTER //
// ./src/modules/config/selectors.js